import { render, staticRenderFns } from "./v-cascader.vue?vue&type=template&id=1d492d3a&scoped=true&"
import script from "./v-cascader.vue?vue&type=script&lang=js&"
export * from "./v-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d492d3a",
  null
  
)

export default component.exports